import { render } from "./ProductForm.vue?vue&type=template&id=0ed8c8c8&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"

import "./ProductForm.vue?vue&type=style&index=0&id=0ed8c8c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed8c8c8"]])

export default __exports__